import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signGeneralAttestationDocumentInput,
  useChSignGeneralAttestationMutation as useChSignGeneralAttestationMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useChSignGeneralAttestationMutation($input: Ch_signGeneralAttestationDocumentInput!) {
    ch_signGeneralAttestationDocument(input: $input) {
      ch_GeneralAttestation {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignGeneralAttestationMutationType>, "variables"> & {
  id: Ch_signGeneralAttestationDocumentInput["id"]
}

const useChSignGeneralAttestationMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignGeneralAttestationMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignGeneralAttestationMutation }
